// How long a question to Torre may be. Admins set it (Admin → Torre, max_message_chars, 80–400;
// backend/services/torre/settings.py BOUNDS) and GET /api/assistant/config says what it is now.
// The box had 200 written in: set to 300 a longer question could not be typed, set to 100 it was
// typed in full and then refused by the server. 200 (the server's default) until the answer
// arrives, or when it cannot be read.
export const DEFAULT_MSG_LENGTH = 200;
export const MIN_MSG_LENGTH = 80;
export const MAX_MSG_LENGTH_CAP = 400;

export function messageLimit(config) {
  const n = Number(config?.max_message_chars);
  if (!Number.isFinite(n) || n <= 0) return DEFAULT_MSG_LENGTH;
  return Math.min(MAX_MSG_LENGTH_CAP, Math.max(MIN_MSG_LENGTH, Math.round(n)));
}
